import React from 'react';
import { Grid } from '@mui/material';
import { ERouteLinks } from 'models/route';
import BoxLink from 'components/atoms/BoxLink';
import { StyledTitle } from 'pages/DashboardPage/styles';

const DashboardAdditionalGuidance = () => (
  <Grid container rowGap="20px">
    <Grid item xs={12}>
      <StyledTitle variant="h4">Additional Guidance</StyledTitle>
    </Grid>
    <Grid item container xs={12} rowGap="20px">
      <Grid item xs={12}>
        <BoxLink
          link={ERouteLinks.Dashboard}
          textLink="Lost or stolen firearms"
          text="This page contains best practice guidance on taking care of your firearms."
        />
      </Grid>
      <Grid item xs={12}>
        <BoxLink
          link={ERouteLinks.Dashboard}
          textLink="Firearms and mental health"
          text="This page explains the support available to you, and the responsibilities you have, if you are struggling with your mental  health."
        />
      </Grid>
      <Grid item xs={12}>
        <BoxLink
          link={ERouteLinks.Dashboard}
          textLink="Air weapons"
          text="Understand the rules regarding air weapons."
        />
      </Grid>

      <Grid item xs={12}>
        <BoxLink
          link={ERouteLinks.Dashboard}
          textLink="Explosive Certificates and Explosive Storage Licences"
          text="Understand the rules regarding explosives and their storage."
        />
      </Grid>
      <Grid item xs={12}>
        <BoxLink
          link={ERouteLinks.Dashboard}
          textLink="Explosive Precursors and Poisons"
          text="Understand the rules regarding explosive precursors and poisons."
        />
      </Grid>
      <Grid item xs={12}>
        <BoxLink
          link={ERouteLinks.Dashboard}
          textLink="Bequesting firearms"
          text="This page provides guidance on how to choose someone to inherit your licensed firearms or shotguns after you die."
        />
      </Grid>
      <Grid item xs={12}>
        <BoxLink
          link={ERouteLinks.Dashboard}
          textLink="Inheriting firearms"
          text="This page provides guidance to those who have inhereted firearms or shotguns."
        />
      </Grid>
      <Grid item xs={12}>
        <BoxLink
          link={ERouteLinks.Dashboard}
          textLink="Hunting"
          text="This page explains best practice regarding hunting with firearms."
        />
      </Grid>
      <Grid item xs={12}>
        <BoxLink
          link={ERouteLinks.Dashboard}
          textLink="Traveling with firearms"
          text="Find out how to apply for a visitor's permit, or to travel abroad with your firearms."
        />
      </Grid>
      <Grid item xs={12}>
        <BoxLink
          link={ERouteLinks.Dashboard}
          textLink="Recent changes to be aware of"
          text="Keep up to date with legislative changes."
        />
      </Grid>
    </Grid>
  </Grid>
);

export { DashboardAdditionalGuidance };
